import { computed, ref } from "vue";
import { getActivityCodesLookup, } from "../infrastructure/adapters/organisationService";
import { logger } from "../../../infrastructure/services/LoggerService";
// Module-scope cache: the NAF catalogue is static and shared by every activityCode dropdown
// in the app, so we fetch it once and reuse the same promise/value across components.
const entries = ref([]);
let inFlight = null;
/**
 * Single-fetch loader for the INSEE NAF rev. 2 catalogue served by the BFF.
 * NAF is a French nomenclature; the BFF returns the official French label per code,
 * which the consuming component formats as <code>"{code} – {label}"</code> in the dropdown.
 */
export function useActivityCodeCatalog() {
    const loading = ref(false);
    async function load() {
        if (entries.value.length > 0)
            return;
        if (inFlight) {
            await inFlight;
            return;
        }
        loading.value = true;
        inFlight = getActivityCodesLookup();
        try {
            entries.value = await inFlight;
        }
        catch (error) {
            logger.error("Failed to load activity codes catalogue", error);
        }
        finally {
            inFlight = null;
            loading.value = false;
        }
    }
    return {
        entries: computed(() => entries.value),
        loading: computed(() => loading.value),
        load,
    };
}
